module.exports = __webpack_public_path__ + "static/nature-light-85f6401ae42087353e4519a6d59ef939.mp4";